import { IComponentCO2LinkCreateSchema } from '@acies/schema';

export default class CreateComponentCO2LinkModel {
	public createComponenCO2LinkButtonEnabled: boolean;
	public createButtonEnabled: boolean;
	public key: string;
	public description: string;
	public createSpinnerVisible: boolean;
	public currentSelectedComponentCO2Self: string;
	public networkErrorLabelVisible: boolean;
	public unknownErrorLabelVisible: boolean;
	public constructor() {
		this.resetUIBindings();
		this.createComponenCO2LinkButtonEnabled = false;
		this.createButtonEnabled = false;
		this.createSpinnerVisible = false;
		this.currentSelectedComponentCO2Self = '';
		this.networkErrorLabelVisible = false;
		this.unknownErrorLabelVisible = false;
	}

	public resetUIBindings(): void {
		this.key = '';
		this.description = '';
	}

	/** Returns a correctly shaped Object that we use in the CO2Service. */
	public get createComponentCO2LinkBody(): IComponentCO2LinkCreateSchema {
		return {
			description: this.description,
			name: this.key,
			co2: {
				self: this.currentSelectedComponentCO2Self,
			},
		};
	}
}
